import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { connect } from 'react-redux';

import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import DoneIcon from '@material-ui/icons/Done';

import { useStyles, tabStyles } from './styles';

const TabsMenu = ({ activeTab, title, isDoneTab, tabs, change }) => {
  const classes = useStyles();
  const tabClasses = tabStyles();
  const [t] = useTranslation();

  let isAllPreviousValid = true;

  tabs.map(item => {
    item.isValid = isDoneTab(item);
    item.isAvailable = true;
    if (!isAllPreviousValid) item.isAvailable = false;
    if (!item.isValid) {
      isAllPreviousValid = false;
    }
  });

  return (
    <div className={classes.container}>
      <Typography variant="h2" className={classes.title}>
        {t(title)}
      </Typography>

      <Tabs
        onChange={change}
        orientation="vertical"
        value={activeTab}
        classes={{ indicator: classes.indicator }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            className={classNames({
              [classes.tabIsAvailable]: tab.isAvailable
            })}
            label={
              <div
                className={classNames(
                  classes.customLabel,
                  {
                    [classes.tabIsFilled]: tab.isValid
                  },
                  { [classes.selectedLabel]: index === activeTab }
                )}
              >
                {tab.isValid && (
                  <DoneIcon classes={{ root: classes.doneIcon }} />
                )}
                {t(tab.name)}
              </div>
            }
            classes={tabClasses}
          />
        ))}
      </Tabs>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.form
  };
};

export default connect(mapStateToProps, null)(TabsMenu);
